import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

export function getPhoneValidationMessage(val: string): string | null {
  if (isValidPhoneNumber(val)) return null;

  try {
    const parsed = parsePhoneNumber(val);
    const country = parsed?.country;
    if (country) {
      const name = displayNames.of(country);
      if (name) return `Please enter a valid ${name} phone number`;
    }
  } catch {
    // ignore parse errors
  }

  return 'Please enter a valid phone number';
}
